// src/lib/api/workplaceApi.ts — the candidate's "Min arbetsplats" data.
import { getApiClient } from './client';

export interface Colleague {
    name: string;
    role: 'employee' | 'employer';
    picture_url?: string | null;
}

export interface Workplace {
    organisation_id: string;
    organisation_name: string;
    organisation_logo_url?: string; // #40; absent → name-derived placeholder
    unit_id: string;
    unit_name: string;
    title: string; // role the candidate was hired into (may be empty for invite-hires)
    started_at: string;
    colleagues: Colleague[];
}

const getMyWorkplace = async (): Promise<Workplace[]> => {
    try {
        const res = await getApiClient().get<{ workplaces: Workplace[]; total: number }>('/api/my/workplace');
        return res.workplaces ?? [];
    } catch {
        return [];
    }
};

export const workplaceApi = { getMyWorkplace };
